import { queryOptions } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';

export const founderQueries = {
  slotsRemaining: () =>
    queryOptions({
      queryKey: ['founder-slots-remaining'] as const,
      queryFn: async (): Promise<number> => {
        const { data, error } = await supabase.rpc('founder_slots_remaining');
        if (error) throw error;
        return typeof data === 'number' ? data : 0;
      },
      staleTime: 60_000,
      refetchInterval: 60_000,
    }),
};
